import { useMe } from '@salescore/client-common'
import { isSameNodeProperty, type NodePropertyName, type ViewConfigField, type ViewConfigSheet } from '@salescore/core'
import { Array, Filter } from 'effect'
import { useState } from 'react'

import { getCanEditField } from '../../recoil/view/functions/filterRelated'

export const useResolveConfigFields = (configIndex: number | undefined) => {
  const me = useMe()
  const [addedColumnCount, setAddedColumnCount] = useState(0)

  return ({
    toggleNodeProperties,
    config,
  }: {
    toggleNodeProperties: NodePropertyName[]
    config: ViewConfigSheet
  }): ViewConfigField[] => {
    if (configIndex === undefined) return []
    const targetIndex = configIndex + addedColumnCount
    const canEditField = getCanEditField(me)
    if (!canEditField) {
      return [] // 本来辿り着かないはずなので、特にメッセージなどは出さない（出したいが、recoilの中でメッセージを表示させる機構が現状ない）
    }
    // eslint-disable-next-line sonarjs/todo-tag
    // TODO: このレイヤでnode,model,propertyのチェックは行うか？
    // const { streams } = useRecoilValue(connectionsSelector)
    // const { getNodeName } = useRecoilValue(querySelector)
    const fields = config.fields ?? []
    const fieldProperties = fields.map((x) => x.property)
    // config.fieldsにないものを追加、既に含まれているものを削除。追加と削除を同時に行うことはなさそうなので、片方は空になる想定。
    const [toRemoveProperties, toAddProperties] = Array.partition(
      toggleNodeProperties,
      Filter.fromPredicate((nodeProperty) => isNodePropertyIncluded(nodeProperty, fieldProperties)),
    )
    const newFields: ViewConfigField[] = toAddProperties.map((property) => ({ type: 'property', property }))
    setAddedColumnCount((x) => Math.max(x + toAddProperties.length - toRemoveProperties.length, 0))
    return [...fields.slice(0, targetIndex + 1), ...newFields, ...fields.slice(targetIndex + 1)].filter(
      (field) => !isNodePropertyIncluded(field.property, toRemoveProperties),
    )
  }
}

export const isNodePropertyIncluded = (x: NodePropertyName, ys: NodePropertyName[]): boolean =>
  ys.some((y) => isSameNodeProperty(x, y, false))
